import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/Service/Common.service';
import { ElementLinkService } from 'src/app/Service/element-link/element-link.service';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { AddElementLinkDialogComponent } from '../dialogs/add-element-link-dialog/add-element-link-dialog.component';
import { ElementLinkModel } from 'src/app/ViewModel/ElementLinkModel';
import { NotificationService } from 'src/app/Service/notification.service';
import * as moment from 'moment';

@Component({
	selector: 'app-element-link',
	templateUrl: './element-link.component.html',
	styleUrls: ['./element-link.component.css']
})
export class ElementLinkComponent implements OnInit {

	/** Selected Business List Id */
	businessGroupId = null;
	buttonToggle = "ELEMENT"; // default value; Onload value;
	isElement = true;
	isStaticElement = false;
	elementLinkList!: ReadonlyArray<ElementLinkModel>;
	enableFilter = false;
	enableFullscreen = false;

	public pageSize = [5, 10, 20, {
		text: 'All',
		value: 'all'
	}];
	constructor(public elementLinkService: ElementLinkService,
		public mapRoleFeatureService: MapRoleFeatureService,
		public commonService: CommonService,
		private dialog: MatDialog,
		private notificationService: NotificationService,
	) { }

	ngOnInit() { }

	getDocumentElements() {
		this.elementLinkService.getDocumentElements(this.commonService.getProjectId(), false).subscribe((data: ElementLinkModel[]) => {
			this.elementLinkList = data;
		});
	}


	changeBusinessGroup(event: any) {
		if (event.value != '-2') {
			this.elementLinkService.selectedBusinessGrpId = event.value;
			this.getDocumentElements();
		} else {
			this.clearData();
		}
	}

	clearData() {
		this.elementLinkService.selectedBusinessGrpId = null;
		this.elementLinkService.clearBusinessGroup = 'Y';
		this.elementLinkList = [];
	}

	/**
	 * Button Toggle Event Handle
	 * @param event 
	 */
	changeButtonToggle(event: any) {
		this.buttonToggle = event.value;

		// Element selected in button toggle
		if (this.buttonToggle == 'ELEMENT') {
			this.isElement = true;
			this.isStaticElement = false;
		} else {
			// Static Element selected in button toggle
			this.isElement = false;
			this.isStaticElement = true;
		}
	}

	addEditElementLink(dataItem: ElementLinkModel, isCreate: boolean) {
		if (this.elementLinkService.selectedBusinessGrpId) {
			let dialogRef = this.dialog.open(AddElementLinkDialogComponent, {
				panelClass: 'mat-dialog-secondary',
				width: '95%',
				minWidth: '95vw',
				disableClose: true,
				data: {
					dataItem,
					isCreate,
					businessGroupId: this.elementLinkService.selectedBusinessGrpId,
				},
			});

			dialogRef.afterClosed().subscribe(data => {
				if (data['isChangesDone']) {
					this.getDocumentElements();
				}
			});
		} else {
			this.notificationService.showToast('Select Business Group', 'Warning');
		}
	}

	toggleFilter() {
		this.enableFilter = !this.enableFilter;
	}

	toggleFullscreen() {
		this.enableFullscreen = !this.enableFullscreen;
	}


}
